export const ADD_RATING_FOR_ORDER = "ADD_RATING_FOR_ORDER";
export const GET_RATABLE_ORDER_DETAILS = "GET_RATABLE_ORDER_DETAILS";
export const GET_REVIEWS_OF_STORE = "GET_REVIEWS_OF_STORE";
